// Routes used in the definition of the Wallet routing system
export enum RawWalletRoutes {
  FLEXI_REWARD_CATEGORY = "/flexi-reward/categories/:category?",
  FLEXI_REWARD_INFO = "/flexi-reward/info/:urlSlug"
}
// Routes used for navigation purposes (excluding parameters)
export enum WalletRoutes {
  REWARD_WALLET = "/reward",
  SEND_CREDIT = "/send-credit",
  FLEXI_BUDGET = "/flexi-budgets",
  FLEXI_CHECKOUT = "/flexi-checkout",
  FLEXI_REWARD = "/flexi-reward",
  FLEXI_ASSIGN = "/flexi-assign",
  FLEXI_REWARD_CATEGORY = "/flexi-reward/categories",
  FLEXI_REWARD_INFO = "/flexi-reward/info"
}
